var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-steps',{attrs:{"active":_vm.steping,"align-center":""}},[_c('el-step',{attrs:{"title":_vm.$t('corp.find_pwd_step1'),"description":""}}),_c('el-step',{attrs:{"title":_vm.$t('corp.find_pwd_step2'),"description":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }